import IconButtonAnimate from "src/components/animate/IconButtonAnimate";
import Iconify from "src/components/Iconify";

// ----------------------------------------------------------------------

type Props = {
	onClick: () => void;
};

// ----------------------------------------------------------------------

export default function DrawerMenuBtn({ onClick }: Props) {
	return (
		<IconButtonAnimate
			onClick={onClick}
			sx={{ mr: 1, color: "text.primary", m: { xs: 1.5, sm: 3 } }}
		>
			<Iconify icon='eva:menu-2-fill' />
		</IconButtonAnimate>
	);
}
